import React from "react";
import { Button } from "semantic-ui-react";

const CommentsButton = (props) => {
  const { color, onClick, content } = props;
  return (
    <Button
      content={content ?? "Comments"}
      color={color ?? "black"}
      onClick={onClick}
      icon="chat"
    />
  );
};

export default CommentsButton;
